export default __webpack_public_path__ + "static/media/close.450b48ce.svg";